import { Grid } from "@mui/material"
import { PaperBox } from "../../../../../components/Layout/PaperBox"
import { CardProps } from ".."
import { formatarCPFCNPJ } from "../../../../../helpers/masks"
import { DadoValorPrinter } from "../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter"
import { verificarStringVazia } from "../../../../../helpers/verificadores"
import moment from "moment"

export const CardDadosGerais = ({
    data
}: CardProps) => {
    return (
        <PaperBox title="Dados gerais">
            <Grid container rowGap={2}>
                {data.data_cadastro &&
                    <Grid size={{xs:6}}>
                        <DadoValorPrinter titulo="Data admissão" valor={moment(data.data_cadastro).format('DD/MM/YYYY')} />
                    </Grid>
                }
                <Grid size={{xs:6}}>
                    <DadoValorPrinter titulo="Documento" valor={formatarCPFCNPJ(data.documento_pessoa)} />
                </Grid>

                <Grid size={{xs:6}}>
                    <DadoValorPrinter titulo="E-mail" valor={verificarStringVazia(data.email)} />
                </Grid>

                <Grid size={{xs:6}}>
                    <DadoValorPrinter titulo="Telefone" valor={verificarStringVazia(data.telefone)} />
                </Grid>

                <Grid size={{xs:6}}>
                    <DadoValorPrinter titulo="Endereço" valor={verificarStringVazia(data.endereco)} />
                </Grid>

                <Grid size={{xs:6}}>
                    <DadoValorPrinter titulo="Bairro" valor={verificarStringVazia(data.bairro)} />
                </Grid>

                <Grid size={{xs:6}}>
                    <DadoValorPrinter titulo="Cidade" valor={verificarStringVazia(data.cidade?.nome || "")} />
                </Grid>

                {!data.data_cadastro && <Grid size={{xs:6}}></Grid>}

                <Grid size={{xs:6, md: 3}}>
                    <DadoValorPrinter titulo="UF" valor={verificarStringVazia(data.cidade?.estado || "")} />
                </Grid>

                <Grid size={{xs:6, md: 3}}>
                    <DadoValorPrinter titulo="CEP" valor={verificarStringVazia(data.cep)} />
                </Grid>

                <Grid size={{xs:6, md: 3}}>
                    <DadoValorPrinter titulo="Permite envio de restrição ao serasa" valor={data.bloqueado_serasa} />
                </Grid>
            </Grid>
        </PaperBox>
    )
}



